export default __webpack_public_path__ + "static/kouraiScene4-47fb2c7d8402c30877b98e8375e0ea2e.mp4";